import React from "react";
import "../styles/Logo.css";
import { useLanguage } from "../contexts/LanguageContext";
import { slotsLeftThisMonth } from "../utils/scarcity";

const Hero = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const hero = text.hero;
  const sc = text.scarcity;
  const slots = slotsLeftThisMonth(sc.monthlySlots);

  return (
    <section id="home" className="hero" dir={isHeb ? "rtl" : "ltr"}>
      <div className="hero-grid" aria-hidden="true" />
      <div className="hero-inner">
        <div className="hero-copy">
          <span className="eyebrow">
            <span className="eyebrow-dot" /> {hero.badge}
          </span>

          <h1 className="hero-title">
            <span>{hero.titleLine1} </span>
            <span className="gradient-text">{hero.titleAccent}</span>
          </h1>

          <p className="hero-lede">{hero.lede}</p>

          <div className="hero-scarcity">
            <span className="scarcity-pill scarcity-slots">
              <span className="scarcity-num">{slots}</span>
              <span>{sc.slotsLabel}</span>
            </span>
            <span className="scarcity-pill scarcity-reply">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l3 2" strokeLinecap="round" />
              </svg>
              <span>{sc.replyTime}</span>
            </span>
          </div>

          <div className="hero-ctas">
            <a className="btn btn-primary" href="#contact">
              {hero.primaryCta}
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
            <a className="btn btn-ghost" href="#services">
              {hero.secondaryCta}
            </a>
          </div>

          <div className="hero-marquee">
            {hero.marquee.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        </div>

        <div className="hero-visual" aria-hidden="true">
          <div className="hero-window">
            <div className="hero-window-bar">
              <span className="hero-window-dot dot-r" />
              <span className="hero-window-dot dot-y" />
              <span className="hero-window-dot dot-g" />
              <span className="hero-window-title">{hero.codePreview.title}</span>
            </div>
            <div className="hero-window-body">
              {hero.codePreview.lines.map((line, i) => (
                <div key={i} className={`code-line code-${line.type}`}>
                  {line.text}
                </div>
              ))}
              <div className="code-cursor" />
            </div>
          </div>

          <div className="hero-orbit">
            <span className="orbit-chip orbit-chip-1">⚡ Lighthouse 95+</span>
            <span className="orbit-chip orbit-chip-2">🤖 AI ready</span>
            <span className="orbit-chip orbit-chip-3">🚀 Live in weeks</span>
          </div>
        </div>
      </div>

    </section>
  );
};

export default Hero;
